import * as React from 'react'

import { cn } from '@/lib/utils'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot='input'
      className={cn(
        'file:text-black-200 placeholder:text-grey-500 disabled:bg-white-200 disabled:text-grey-500 bg-white-100 flex h-9 w-full min-w-0 rounded-md border p-2.5 text-sm transition-colors outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm disabled:pointer-events-none disabled:cursor-not-allowed',
        'focus-visible:ring-[2px] focus-visible:ring-[#DBEEFF]',
        'aria-invalid:border-red-300 aria-invalid:ring-red-300/20 dark:aria-invalid:ring-red-300/40',
        className
      )}
      {...props}
    />
  )
}

export { Input }
